import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import styles from './MarketingShared.module.css';

/**
 * Cartão da lista (campanhas ou origens): título com o total, busca por nome
 * e as linhas. `showSearch` some no estado vazio e no carregamento.
 */
function MarketingListCard({ title, count, searchTerm, onSearchChange, showSearch = true, children }) {
  return (
    <section className={styles.card}>
      <header className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>
          {title}
          {count != null && <span className={styles.count}>{count}</span>}
        </h3>
        {showSearch && (
          <TextField
            size="small"
            placeholder="Buscar por nome"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className={styles.search}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon fontSize="small" sx={{ color: 'var(--color-text-light)' }} />
                </InputAdornment>
              ),
            }}
          />
        )}
      </header>
      {children}
    </section>
  );
}

export default MarketingListCard;
